import logo from './logo.svg';
import { Link, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import { FaGithub, FaInstagram, FaLinkedin, FaTwitter, FaFacebook, FaWhatsapp } from 'react-icons/fa';
import Home from './Home.js';
import Web_projects from './Web_project.js';
import App_projects from './App_projects.js';
import Block_projects from './Block_projects.js';
import VR from './VR.js';
import Ai from './Ai.js';
import Hackathon from './Hackathon.js';

function App() {

  return (
    <div className="App">
      <div class="parent-container">
        <div class="child-container">
          <div class="child">
            <img src="profile.jpeg"></img>
            <h2>Prince Maurya</h2>
            <p>Projects</p>
            <div class="icons">
              <a href="https://github.com/Prince200510" target="_blank" rel="noopener noreferrer">
                <FaGithub size={30} color="#333" />
              </a>
              <a href="https://www.linkedin.com/in/prince-maurya-810b83277/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={30} color="#0077B5" />
              </a>
              <a href="https://wa.me/9987742369" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp size={30} color="#25D366" />
              </a>
              <a href="https://x.com/PrinceM73729067" target="_blank" rel="noopener noreferrer">
                <FaTwitter size={30} color="#1DA1F2" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100073312225818" target="_blank" rel="noopener noreferrer">
                <FaFacebook size={30} color="#1877F2" />
              </a>
              <a href="https://www.instagram.com/princemaurya_10?igshid=MzNlNGNkZWQ4Mg%3D%3D" target="_blank" rel="noopener noreferrer">
                <FaInstagram size={30} color="#E4405F" />
              </a>
            </div>
            <div className="container">
             <Routes>
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/Ai" element={<Ai />} />
                <Route path="/Web_projects" element={<Web_projects />} />
                <Route path="/Block_projects" element={<Block_projects />} />
                <Route path="/App_projects" element={<App_projects />} />
                <Route path="/VR_projects" element={<VR />} />
                <Route path="/Hackathon" element={<Hackathon />} />
             </Routes>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
